<template>
    <div class="btn-create-v2" v-click-outside="close">
        <BmvButton
            :icon="'fal fa-plus'"
            :icon-right="open ? 'fal fa-chevron-up' : 'fal fa-chevron-down'"
            size="sm"
            @click="open = !open"
        >
            <span class="btn-create-v2-label">{{ $t('topbar.new') }}</span>
        </BmvButton>
        <div v-if="open" class="btn-create-v2-menu" role="menu">
            <router-link
                to="/post/create/forms"
                class="btn-create-v2-item"
                @click.native="close"
            >
                <i class="fal fa-ticket"></i>
                <span>{{ $t('topbar.ticket') }}</span>
            </router-link>
            <router-link
                to="/forms/builder"
                class="btn-create-v2-item"
                @click.native="close"
            >
                <i class="fal fa-poll"></i>
                <span>{{ $t('topbar.form') }}</span>
            </router-link>
            <router-link
                to="/admin/template/create"
                class="btn-create-v2-item"
                @click.native="close"
            >
                <i class="fal fa-file-alt"></i>
                <span>{{ $t('topbar.template') }}</span>
            </router-link>
        </div>
    </div>
</template>

<script>
import BmvButton from '@/components/UI/v2/BmvButton.vue'

export default {
    name: 'ButtonCreateV2',
    components: { BmvButton },
    directives: {
        'click-outside': {
            bind(el, binding) {
                el._clickOutside = (e) => {
                    if (!el.contains(e.target)) binding.value()
                }
                document.addEventListener('mousedown', el._clickOutside)
            },
            unbind(el) {
                document.removeEventListener('mousedown', el._clickOutside)
            }
        }
    },
    data() {
        return { open: false }
    },
    methods: {
        close() {
            this.open = false
        }
    }
}
</script>

<style scoped>
.btn-create-v2 {
    position: relative;
}

.btn-create-v2-label {
    display: none;
}

@media (min-width: 640px) {
    .btn-create-v2-label {
        display: inline;
    }
}

.btn-create-v2-menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    min-width: 200px;
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    box-shadow: var(--v2-shadow-lg);
    padding: 4px;
    z-index: 40;
    font-family: var(--v2-font-sans);
}

.btn-create-v2-item {
    display: flex;
    align-items: center;
    gap: var(--v2-space-3);
    padding: 8px var(--v2-space-3);
    border-radius: var(--v2-radius-sm);
    color: var(--v2-text-2);
    font-size: var(--v2-text-sm-size);
    text-decoration: none;
    transition: background var(--v2-transition-fast),
        color var(--v2-transition-fast);
}

.btn-create-v2-item:hover {
    background: var(--v2-primary-soft);
    color: var(--v2-primary);
}

.btn-create-v2-item i {
    width: 18px;
    font-size: 0.9rem;
    flex-shrink: 0;
    color: var(--v2-text-4);
}

.btn-create-v2-item:hover i {
    color: var(--v2-primary);
}
</style>
